import { Injectable } from "@angular/core";
import { CachedTranslationCatalog } from "@core/models/translation/translation.models";
import { TRANSLATION_CACHE_STORAGE_PREFIX } from "@core/constants/translation.config";

@Injectable({ providedIn: "root" })
export class TranslationCacheService {
  get(locale: string): CachedTranslationCatalog | null {
    try {
      const raw = localStorage.getItem(this.cacheKey(locale));
      return raw ? (JSON.parse(raw) as CachedTranslationCatalog) : null;
    } catch {
      return null;
    }
  }

  set(catalog: CachedTranslationCatalog): void {
    localStorage.setItem(
      this.cacheKey(catalog.locale),
      JSON.stringify(catalog),
    );
  }

  clearAll(): void {
    const prefix = `${TRANSLATION_CACHE_STORAGE_PREFIX}:`;
    const keysToRemove: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  }

  private cacheKey(locale: string): string {
    return `${TRANSLATION_CACHE_STORAGE_PREFIX}:${locale}`;
  }
}
